import React from 'react';
import PropTypes from 'prop-types';

const ColumnPicker = ({ csvColumns, selectedColumns, onToggle, onSelectAll, onDeselectAll, collapsible, showColumnPicker, onToggleVisibility }) => {
  const picker = (
    <div>
      <div className="d-flex justify-content-end mb-1">
        <a href="#" onClick={(e) => { e.preventDefault(); onSelectAll(); }}
          className="small mr-3">
          Select all
        </a>
        <a href="#" onClick={(e) => { e.preventDefault(); onDeselectAll(); }}
          className="small">
          Deselect all
        </a>
      </div>
      <div className="border rounded p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
        {csvColumns.map((col) => (
          <div className="form-check" key={col.key}>
            <input
              type="checkbox"
              className="form-check-input"
              id={`col-${col.key}`}
              checked={selectedColumns.includes(col.key)}
              onChange={() => onToggle(col.key)}
            />
            <label className="form-check-label" htmlFor={`col-${col.key}`}>
              {col.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );

  if (collapsible) {
    return (
      <div className="mb-3">
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); onToggleVisibility(); }}
          className="small"
        >
          {showColumnPicker ? "Hide" : "Customize"} columns ({selectedColumns.length} selected)
        </a>
        {showColumnPicker && <div className="mt-2">{picker}</div>}
      </div>
    );
  }

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="mb-0"><strong>Columns</strong></label>
        <div>
          <a href="#" onClick={(e) => { e.preventDefault(); onSelectAll(); }}
            className="small mr-3">
            Select all
          </a>
          <a href="#" onClick={(e) => { e.preventDefault(); onDeselectAll(); }}
            className="small">
            Deselect all
          </a>
        </div>
      </div>
      <div className="border rounded p-2" style={{ maxHeight: "300px", overflowY: "auto" }}>
        {csvColumns.map((col) => (
          <div className="form-check" key={col.key}>
            <input
              type="checkbox"
              className="form-check-input"
              id={`col-${col.key}`}
              checked={selectedColumns.includes(col.key)}
              onChange={() => onToggle(col.key)}
            />
            <label className="form-check-label" htmlFor={`col-${col.key}`}>
              {col.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

ColumnPicker.propTypes = {
  csvColumns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedColumns: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  collapsible: PropTypes.bool,
  showColumnPicker: PropTypes.bool,
  onToggleVisibility: PropTypes.func
};

export default ColumnPicker;
